import { AI_ACTION, COMMON_TRANSFORM_RESPONSE_FUNCTION } from "../../../app/constants/api";
import { apiSlice } from "../../../app/redux/apiSlice";

export const aiApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    aiAction: builder.mutation({
      query: ({ action, payload = {} }) => ({
        url: AI_ACTION.BASE,
        method: "POST",
        body: { action, payload },
      }),
      ...COMMON_TRANSFORM_RESPONSE_FUNCTION,
    }),
  }),
});

export const { useAiActionMutation } = aiApiSlice;
